"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Product = void 0;
var _mui = require("@ori-ui/mui");
var _presentationProductDetail = require("@ori/presentation-product-detail");
var _internal = require("../../hooks/internal");
var _useTranslations = require("../../hooks/useTranslations");
var _utils = require("../../utils");
var _Buttons = require("../Buttons");
var _GroupedProducts = require("../GroupedProducts");
var _Loading = require("../Loading");
var _ProductInfo = require("../ProductInfo");
var _Subscriptions = require("../Subscriptions");
var _Price = require("./Price");
var _Rating = require("./Rating");
var _Shades = require("./Shades");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const Product = () => {
  const {
    translations
  } = (0, _useTranslations.useTranslations)();
  const {
    currentShade: {
      canBeSold,
      nextAvailableDateText,
      pdpUrl,
      productCode
    },
    loading
  } = (0, _internal.useProduct)();
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Root, {
    children: [loading ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Loading.Loading, {}) : null, /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Inner, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_ProductInfo.ProductInfo, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Rating.Rating, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_GroupedProducts.GroupedProducts, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Shades.Shades, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Price.Price, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Subscriptions.Subscriptions, {}), nextAvailableDateText && !canBeSold ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_presentationProductDetail.NextAvailability, {
        title: nextAvailableDateText
      }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Link, {
        href: (0, _utils.getProductDetailUrl)({
          pdpUrl,
          productCode
        }),
        children: translations.viewMoreDetails
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Buttons.Buttons, {})]
  });
};
exports.Product = Product;
